module.exports = __webpack_public_path__ + "img/about_banner.0b601c78.png";